import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@krea/shared/design-system/avatar";

import { useGetMeQuery } from "../hooks/use-get-me.query";

export const MeAvatar = () => {
  const { data: me } = useGetMeQuery();

  if (!me) {
    return null;
  }
  const fullName = `${me.firstName} ${me.lastName}`;

  return (
    <div className="hidden sm:flex sm:items-center sm:gap-3 ">
      <Avatar className="h-8 w-8 rounded-md">
        <AvatarImage src={""} alt={fullName} />
        <AvatarFallback className="rounded-md">
          {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
          {`${(me.firstName ?? "")[0]}${(me.lastName ?? "")[0]}`.toUpperCase()}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-semibold">{fullName}</span>
        <span className="text-xs text-black-300">{me.email}</span>
      </div>
    </div>
  );
};
